import React, { useState, useEffect, Fragment, useContext } from 'react'
import formatCPF from '@brazilian-utils/format-cpf'
import { onlyNumbers } from '@brazilian-utils/helper-only-numbers'
import { format, startOfMonth } from 'date-fns'
import Select from 'react-select'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import moment from 'moment'

import RelatorioService from '../../services/relatorio.service'
import PageLoading from '../Common/PageLoading'
import { Table, Button, Spinner, Row, Col, OverlayTrigger, Tooltip, Card, Form, Modal } from 'react-bootstrap'
import Paginator from '../Common/Paginator'
import CSVDownload from './CSVDownload'
import colaboradoresService from '../../services/colaboradores.service'
import Swal from 'sweetalert2'
import MenuContext from '../../contexts/MenuContexts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { formatMoney } from '../../utils/string.utils'
import { statusPlanoTratamento } from '../../constants/common.constants'

const obterTelefoneContato = (grupo) => {
  const whatsApp = grupo.telefonesWhatsApp?.split(',')[0]?.trim()
  if (whatsApp) return whatsApp
  return grupo.telefonePrincipal || '-'
}

const obterStatusTratamento = (status) => {
  const item = statusPlanoTratamento.find((s) => s.value === status)
  return item ? item.label : '-'
}

const possuiTratamentoVinculado = (grupo) =>
  grupo?.numeroPlano || (grupo?.planoTratamentoId && grupo.planoTratamentoId !== '00000000-0000-0000-0000-000000000000')

export default function PacientesDesnegativados({ selectedRelatorio }) {
  const itensPorPagina = 20
  const acoes = useContext(MenuContext)
  const [isLoading, setLoading] = useState(false)
  const [isLoadingCSV, setLoadingCSV] = useState(false)
  const [gruposLista, setGruposLista] = useState([])
  const [cabecalhoRelatorio, setCabecalhoRelatorio] = useState([])
  const [feedbackBusca, setFeedbackBusca] = useState('')
  const [pagina, setPagina] = useState(0)
  const [totalPaginas, setTotalPaginas] = useState(0)
  const [itensCSV, setItensCSV] = useState([])
  const [downloadCSV, setDownloadCSV] = useState(false)
  const [selectedEspecialidade, setSelectedEspecialidade] = useState(null)
  const [selectedDesnegativado, setSelectedDesnegativado] = useState(null)
  const [especialidadeOptions, setEspecialidadeOptions] = useState([])
  const [desnegativadoOptions, setDesnegativadoOptions] = useState([])
  const [filterLoading, setFilterLoading] = useState(false)
  const [resumo, setResumo] = useState([])
  const [acoesPermitidas, setAcoesPermitidas] = useState({})
  const [dateFilterAte, setDateFilterAte] = useState(new Date())
  const [dateFilterDe, setDateFilterDe] = useState(startOfMonth(new Date()))
  const [cpfFilter, setCpfFilter] = useState('')
  const [showModalDetalhes, setShowModalDetalhes] = useState(false)
  const [detalheSelecionado, setDetalheSelecionado] = useState(null)

  const adicionarFiltroCpf = (filtros) => {
    const cpf = onlyNumbers(cpfFilter || '')
    if (cpf) {
      filtros.push({ campo: 'cpf', valor: cpf })
    }
  }

  const obterTotalPacientes = () => {
    const item = resumo?.find((r) => r.descricao === 'Total de pacientes')
    if (!item?.valor) return 0
    const total = parseInt(item.valor, 10)
    return Number.isNaN(total) ? 0 : total
  }

  const totalPacientes = obterTotalPacientes()
  const indiceInicial = totalPacientes === 0 ? 0 : pagina * itensPorPagina + 1
  const indiceFinal = Math.min((pagina + 1) * itensPorPagina, totalPacientes)

  useEffect(() => {
    didMount()
    setCabecalhoRelatorio([
      'Nome',
      'CPF',
      'Telefone',
      'Data Entrada',
      'Desnegativado',
      'Responsavel Operação',
      'Flag'
    ])
  }, [])

  useEffect(() => {
    if (!acoes) {
      return
    }
    const permissoes = {}
    acoes.map((a) => {
      permissoes[`${a.nome}`] = a
      return true
    })
    setAcoesPermitidas(permissoes)
  }, [acoes])

  useEffect(() => {
    handleSearch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagina])

  useEffect(() => {
    if (downloadCSV) {
      setTimeout(() => {
        setDownloadCSV(false)
      }, 500)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itensCSV, downloadCSV])

  const didMount = async () => {
    setFilterLoading(true)

    const { data } = await colaboradoresService.getAllEspecialidades()
    const especialidades = [{ label: 'Todos', value: '00000000-0000-0000-0000-000000000000' }]

    data.map(({ nome, id }) => especialidades.push({
      label: nome,
      value: id,
    }))

    setEspecialidadeOptions(especialidades)
    setSelectedEspecialidade([{ label: 'Todos', value: '00000000-0000-0000-0000-000000000000' }])

    setDesnegativadoOptions([
      { value: '-1', label: 'Todos' },
      { value: '1', label: 'Sim' },
      { value: '0', label: 'Não' },
    ])
    setSelectedDesnegativado({ label: 'Não', value: '0' })

    handleSearch()
    setFilterLoading(false)
  }

  const getValuesLista = async () => {
    const filtros = []
    if (selectedEspecialidade) {
      filtros.push({ campo: 'especialidadeId', valor: selectedEspecialidade.value })
    }
    filtros.push({ campo: 'marcado', valor: selectedDesnegativado ? (selectedDesnegativado.value == '-1' ? '' : selectedDesnegativado.value) : '0' })
    filtros.push({ campo: 'tipoRelatorio', valor: 'desnegativados' })
    adicionarFiltroCpf(filtros)

    if (selectedDesnegativado?.value === '1') {
      dateFilterDe && filtros.push({ campo: 'dataInicial', valor: dateFilterDe })
      dateFilterAte && filtros.push({ campo: 'dataFinal', valor: dateFilterAte })
    }

    setLoadingCSV(true)
    const { lista, resumo } = await RelatorioService.getRegistrosNegativadosAgrupado(filtros, 1, 999999)

    const dados = lista.dados
    setResumo(resumo)

    const valores = []
    dados.forEach((grupo) => {
      valores.push([
        grupo.nome,
        formatCPF(grupo.cpf),
        obterTelefoneContato(grupo),
        grupo.dataCriacao ? format(new Date(grupo.dataCriacao), 'dd/MM/yyyy') : '-',
        grupo.dataDesnegativado ? format(new Date(grupo.dataDesnegativado), 'dd/MM/yyyy') : '-',
        grupo.colaboradorDesnegativacao || '-',
        grupo.desnegativado ? 'Sim' : 'Não',
      ])
    })

    setItensCSV(valores)
    setDownloadCSV(true)
    setLoadingCSV(false)
    return {
      data: valores,
      headers: cabecalhoRelatorio,
      filename: `${selectedRelatorio.label} - ${format(new Date(), 'dd-MM-yyyy')}.csv`,
    }
  }

  const handleSearch = async () => {
    setLoading(true)
    try {
      const filtros = []
      if (selectedEspecialidade) {
        filtros.push({ campo: 'especialidadeId', valor: selectedEspecialidade.value })
      }

      if (selectedDesnegativado?.value === '1') {
        dateFilterDe && filtros.push({ campo: 'dataInicial', valor: dateFilterDe })
        dateFilterAte && filtros.push({ campo: 'dataFinal', valor: dateFilterAte })
      }

      filtros.push({ campo: 'marcado', valor: selectedDesnegativado ? (selectedDesnegativado.value == '-1' ? '' : selectedDesnegativado.value) : '0' })
      filtros.push({ campo: 'tipoRelatorio', valor: 'desnegativados' })
      adicionarFiltroCpf(filtros)

      setFeedbackBusca('')
      const { lista, resumo } = await RelatorioService.getRegistrosNegativadosAgrupado(
        filtros,
        pagina + 1,
        itensPorPagina
      )

      const dados = lista.dados

      setGruposLista(dados)
      setTotalPaginas(lista.totalPaginas)
      setResumo(resumo)

      if (dados.length === 0) {
        setFeedbackBusca('Nenhum registro encontrado')
      }
    } catch (error) {
      console.error(error)
    }
    setLoading(false)
  }

  const handleClear = () => {
    setPagina(0)
    setDateFilterDe(null)
    setDateFilterAte(null)
    setSelectedEspecialidade([{ label: 'Todos', value: '00000000-0000-0000-0000-000000000000' }])
    setSelectedDesnegativado({ label: 'Não', value: '0' })
    setCpfFilter('')
  }

  const handleChangeEspecialidade = (option) => {
    setSelectedEspecialidade(option)
  }

  const handleChangeDesnegativado = (option) => {
    setSelectedDesnegativado(option)
  }

  const handlePagina = async (data) => setPagina(data.selected)

  const handlePesquisar = () => {
    if (pagina !== 0) {
      setPagina(0)
      return
    }
    handleSearch()
  }

  const abrirDetalhes = (grupo) => {
    setDetalheSelecionado(grupo)
    setShowModalDetalhes(true)
  }

  const fecharDetalhes = () => {
    setShowModalDetalhes(false)
    setDetalheSelecionado(null)
  }

  const renderModalDetalhes = () => {
    if (!detalheSelecionado) return null

    const grupo = detalheSelecionado
    const temTratamento = possuiTratamentoVinculado(grupo)

    return (
      <Modal show={showModalDetalhes} onHide={fecharDetalhes} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title>Detalhes da desnegativação</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3 text-muted small">
            Referência do tratamento e parcela relacionados a esta desnegativação para{' '}
            <strong>{grupo.nome?.toUpperCase()}</strong> — {formatCPF(grupo.cpf)}
          </p>

          {temTratamento ? (
            <Table bordered size="sm" className="mb-0">
              <tbody>
                <tr>
                  <th width="40%">Tipo de tratamento</th>
                  <td>{grupo.tipoPlano === 1 ? 'Ortodontia' : 'Clínico geral'}</td>
                </tr>
                <tr>
                  <th>Nº do plano</th>
                  <td>{grupo.numeroPlano || '-'}</td>
                </tr>
                <tr>
                  <th>Status do tratamento</th>
                  <td>{obterStatusTratamento(grupo.statusTratamento)}</td>
                </tr>
                <tr>
                  <th>Parcela</th>
                  <td>{grupo.parcela || '-'}</td>
                </tr>
                <tr>
                  <th>Vencimento</th>
                  <td>{grupo.dataVencimento ? format(new Date(grupo.dataVencimento), 'dd/MM/yyyy') : '-'}</td>
                </tr>
                <tr>
                  <th>Data pagamento</th>
                  <td>{grupo.dataPagamento ? format(new Date(grupo.dataPagamento), 'dd/MM/yyyy') : '-'}</td>
                </tr>
                <tr>
                  <th>Valor da parcela</th>
                  <td>{grupo.valorParcela ? formatMoney(grupo.valorParcela) : '-'}</td>
                </tr>
              </tbody>
            </Table>
          ) : (
            <p className="mb-0 text-muted">Nenhum tratamento vinculado a este registro de desnegativação.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          {grupo.pacienteId && (
            <Button
              variant="outline-primary"
              href={`/pacientes/${grupo.pacienteId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Abrir paciente
            </Button>
          )}
          <Button variant="secondary" onClick={fecharDetalhes}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  const onChangeBoolean = async (grupo, e) => {
    if (!e.target.checked && !acoesPermitidas.DesmarcarNegativacao) {
      Swal.fire({
        title: 'Operação não autorizada',
        text: 'Não é possível realizar essa operação. Por favor, entre em contato com administrador do sistema.',
        type: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
      })
      return
    }

    const checked = !e.target.checked

    const novoItem = {
      idHistoricoNegativacao: grupo.idHistoricoNegativacao,
      pacienteId: grupo.pacienteId,
      nome: grupo.nome,
      cpf: grupo.cpf,
      telefonePrincipal: grupo.telefonePrincipal,
      desnegativado: !checked,
    }

    const mensagem = !checked
      ? 'Ao marcar essa opção você está confirmando que já foi realizada a operação junto ao SPC. Deseja confirmar?'
      : 'Ao desmarcar essa opção você está confirmando que a operação não foi realizada junto ao SPC. Deseja confirmar?'

    Swal.fire({
      title: 'Confirmar Operação',
      text: mensagem,
      type: 'warning',
      showCancelButton: true,
      cancelButtonColor: '#dbdbdb',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Confirmar',
    }).then(async (result) => {
      if (result.value === true) {
        await RelatorioService.confirmarDesnegativacao(novoItem)

        Swal.fire(
          'Confirmado',
          'Operação confirmada com sucesso.',
          'success'
        ).then(async () => {
          await handleSearch()
        })
      }
    })
  }

  const handleDateFilterDe = (date) => {
    if (date) {
      setDateFilterDe(date.toDate())
    } else {
      setDateFilterDe(null)
    }
    setPagina(0)
  }

  const handleDateFilterAte = (date) => {
    if (date) {
      setDateFilterAte(date.toDate())
    } else {
      setDateFilterAte(null)
    }
    setPagina(0)
  }

  const renderItens = () =>
    gruposLista.length > 0 ? (
      <Fragment>
        <div className='mt-4 d-flex justify-content-end align-items-center'>
          <CSVDownload asyncExportMethod={getValuesLista}>
            <Button variant='outline-secondary' className='mb-3'>
              {isLoadingCSV ? <Spinner animation='border' size='sm' variant='light' /> : 'Gerar CSV'}
            </Button>
          </CSVDownload>
        </div>

        <Card className='mb-4 py-2'>
          <Row>
            {resumo?.map(({ descricao, valor }, index) => (
              <Col key={index} className='d-flex align-items-center justify-content-center flex-column'>
                <small className='text-center text-muted m-0'>{!!descricao ? descricao.toUpperCase() : '-'}</small>
                <h4 className='text-center m-0 font-weight-bold'>{valor || '-'}</h4>
              </Col>
            ))}
          </Row>
        </Card>

        <Table hover size='sm' className='border rounded-0 shadow-sm' style={{ backgroundColor: 'white' }}>
          <thead>
            <tr>
              <th width="180px">Nome</th>
              <th width="100px" className="text-center">CPF</th>
              <th width="130px" className="text-left">Telefone</th>
              <th width="90px" className="text-center">Data Entrada</th>
              <th width="90px" className="text-center">Desnegativado</th>
              <th width="120px" className="text-center">Responsável</th>
              <th width="80px" className="text-center">Flag</th>
              <th width="90px" className="text-center">Detalhes</th>
            </tr>
          </thead>
          <tbody>
            {gruposLista.map((grupo, gi) => (
              <tr key={grupo.cpf || gi} style={{ fontSize: 'smaller' }}>
                <td>
                  {grupo.pacienteId ? (
                    <a
                      href={`/pacientes/${grupo.pacienteId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#007bff', textDecoration: 'none', cursor: 'pointer', fontWeight: '500' }}
                      onMouseEnter={(e) => { e.target.style.textDecoration = 'underline' }}
                      onMouseLeave={(e) => { e.target.style.textDecoration = 'none' }}
                      title="Abrir cadastro do paciente em nova aba"
                    >
                      {grupo.nome?.toUpperCase()}{' '}
                      <FontAwesomeIcon icon={faExternalLinkAlt} size="xs" style={{ marginLeft: '5px', opacity: 0.7 }} />
                    </a>
                  ) : (
                    grupo.nome?.toUpperCase()
                  )}
                </td>
                <td className='text-center'>{formatCPF(grupo.cpf)}</td>
                <td className='text-left'>{obterTelefoneContato(grupo)}</td>
                <td className='text-center'>{grupo.dataCriacao ? format(new Date(grupo.dataCriacao), 'dd/MM/yyyy') : '-'}</td>
                <td className='text-center'>{grupo.dataDesnegativado ? format(new Date(grupo.dataDesnegativado), 'dd/MM/yyyy') : '-'}</td>
                <td className='text-center'>{grupo.colaboradorDesnegativacao || '-'}</td>
                <td className='text-center'>
                  <OverlayTrigger trigger='hover' placement='top' overlay={<Tooltip>{grupo.desnegativado ? `Desmarcar como desnegativado no SPC` : `Marcar como desnegativado no SPC`}</Tooltip>}>
                    <label className='checkbox labeless m-0'>
                      <input
                        type='checkbox'
                        checked={grupo.desnegativado}
                        onChange={(e) => onChangeBoolean(grupo, e)}
                      />
                      <span />
                    </label>
                  </OverlayTrigger>
                </td>
                <td className='text-center'>
                  <Button variant='outline-secondary' size='sm' onClick={() => abrirDetalhes(grupo)}>
                    Detalhes
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {totalPaginas > 1 && (
          <p className='text-muted small text-center mb-2'>
            Exibindo {indiceInicial}–{indiceFinal} de {totalPacientes} pacientes
          </p>
        )}
        {totalPaginas > 1 && <Paginator handlePagina={handlePagina} pageCount={totalPaginas} paginaAtual={pagina} />}
        {renderModalDetalhes()}
      </Fragment>
    ) : (
      <div className='mt-4'>{feedbackBusca}</div>
    )

  const renderLoading = () => <PageLoading />

  return (
    <Fragment>
      <Row className='mb-2'>
        <Col md='3'>
          <label>Desnegativado:</label>
          <Select
            placeholder='Desnegativado'
            className='w-100 mr-1'
            onChange={handleChangeDesnegativado}
            value={selectedDesnegativado}
            options={desnegativadoOptions}
          />
        </Col>
        <Col md='3'>
          <label>Especialidade:</label>
          <Select
            placeholder='Especialidade'
            className='w-100 mr-1'
            onChange={handleChangeEspecialidade}
            value={selectedEspecialidade}
            options={especialidadeOptions}
          />
        </Col>
        <Col md='3'>
          <Form.Group>
            <Form.Label>CPF</Form.Label>
            <Form.Control
              type='text'
              placeholder='000.000.000-00'
              value={cpfFilter}
              onChange={(e) => {
                setCpfFilter(e.target.value)
                setPagina(0)
              }}
            />
          </Form.Group>
        </Col>

        {selectedDesnegativado?.value == '1' &&
          <>
            <Col md='3'>
              <Form.Group>
                <Form.Label>Data Inicial</Form.Label>
                <MuiPickersUtilsProvider utils={MomentUtils} locale='pt-br'>
                  <KeyboardDatePicker
                    invalidDateMessage='Formato de data inválido'
                    value={dateFilterDe}
                    onChange={handleDateFilterDe}
                    className='form-control'
                    variant='inline'
                    format='DD/MM/YYYY'
                    minDate={moment(dateFilterAte).add(-90, 'days')}
                    maxDate={dateFilterAte || moment()}
                    animateYearScrolling
                    autoOk
                    placeholder='De'
                  />
                </MuiPickersUtilsProvider>
              </Form.Group>
            </Col>

            <Col md='3'>
              <Form.Group>
                <Form.Label>Data Final</Form.Label>
                <MuiPickersUtilsProvider utils={MomentUtils} locale='pt-br'>
                  <KeyboardDatePicker
                    invalidDateMessage='Formato de data inválido'
                    value={dateFilterAte}
                    onChange={handleDateFilterAte}
                    minDate={dateFilterDe || moment()}
                    maxDate={moment()}
                    className='form-control'
                    variant='inline'
                    format='DD/MM/YYYY'
                    animateYearScrolling
                    autoOk
                    placeholder='Até'
                  />
                </MuiPickersUtilsProvider>
              </Form.Group>
            </Col>
          </>
        }
      </Row>
      <Row className='mb-2'>
        <Col className='text-right'>
          {filterLoading && <Spinner animation='border' variant='primary' size='sm' style={spinnerStyle} />}
          <Button disabled={filterLoading} onClick={handleClear} variant='outline-danger' className='mr-2'>
            Limpar
          </Button>
          {filterLoading && <Spinner animation='border' variant='primary' size='sm' />}
          <Button disabled={filterLoading} onClick={handlePesquisar} variant='primary'>
            Pesquisar
          </Button>
        </Col>
      </Row>
      {isLoading ? renderLoading() : renderItens()}
    </Fragment>
  )
}

const spinnerStyle = {
  position: 'absolute',
  top: '10px',
  right: '50px',
}
